<div *ngIf="mode==='normal'">
  <div class="container" [class.has-mobile-image]="currentSlideTieneMobile">
    <div class="carousel">
      <div class="leftSlide" (click)="onPreviousClick()"></div>
      <div class="rightSlide" (click)="onNextClick()"></div>
      <ng-container *ngFor="let slide of slides; let i = index">
        <picture *ngIf="i === currentSlide">
          <source *ngIf="slide.k.getImagenMobile()" [srcset]="slide.k.getImagenMobile()" media="(max-width: 599px)">
          <img [src]="slide.src" class="slide" [class.slide-sin-mobile]="!slide.k.getImagenMobile()" @carouselAnimation />
        </picture>
      </ng-container>

      <div class="noselect mybtn" [ngStyle]="{'display': carrouselText}">
        <div *ngFor="let slide of slides; let i = index" class="textocontainer" id="textContainer{{i}}">
          <span *ngIf="i === currentSlide" class="textogrande">
            {{slide.k.nombre}}
          </span>
          <span *ngIf="i === currentSlide" class="textochico">
            {{slide.k.abv}}
          </span>
        </div>
      </div>

    </div>
  </div>
  <div class="roundcontainer">
    <div class="roundedOne" *ngFor="let item of slidePosition">
      <input [id]="item.id" type="checkbox" [checked]="item.activado" (change)="onchange(item)" id="item.id" />
      <label [for]="item.id"></label>
    </div>
  </div>

</div>